import { onMounted, watch, computed } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "ProfileDeleted",
    setup(){
        const store = useStore()

        let first,
            last,
            close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        const cancelAction = function(){
            store.dispatch('main/closePageOverlay')
        }

        onMounted(() => {
            
            first = document.querySelector(
                '.kb-button[data-order="first"]'
            )
            last = document.querySelector(
                '.kb-button[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        return {
            cancelAction,
            tabTrap,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'ProfileDeleted',
                    labelKey
                })
        }
    }
}